<template>
    <v-card dense>
        <v-card-title dense color='white black--text' class="subheading" dark>
        Data Set
        <v-spacer/>
            <v-btn icon dark @click="closeDialog" class="text-xs-right">
                <v-icon class="black--text" title="Close">close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text >
            <v-form v-model="valid">
                <v-layout row wrap class="text-xs-left">
                    <v-flex  sm12 >
                        <b>Name</b><br/>
                        <v-text-field
                            class="mr-2 pt-1"
                            outline
                            v-validate="'required'"
                            data-vv-name="name"
                            type="text"
                            :error-messages="errors.collect('name')"
                            v-model="dataset.name"
                            required
                        />
                    </v-flex>
                    <v-flex  sm6 >
                        <b>Type</b><br/>
                        <v-autocomplete attach   
                            class="mr-2 pt-1"
                            outline
                            v-validate="'required'"
                            data-vv-name="type"
                            item-text="name"
                            item-value="id"
                            :error-messages="errors.collect('type')"
                            v-model="dataset.type"
                            :items="settype"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                        <b>Source Type</b><br/>
                        <v-autocomplete attach   
                            class="mr-2 pt-1"
                            outline
                            v-validate="'required'"
                            data-vv-name="type"
                            item-text="name"
                            item-value="id"
                            :error-messages="errors.collect('type')"
                            v-model="dataset.source_type"
                            :items="sourceTypes"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex  v-if="dataset.source_type=='D'" :sm12="dataset.type=='R'"  :sm4="dataset.type!='R'" >
                        <b>Source</b><br/>
                        <v-text-field
                            class="mr-2 pt-1"
                            outline
                            v-validate="'required'"
                            data-vv-name="data_source"
                            type="text"
                            :error-messages="errors.collect('data_source')"
                            v-model="dataset.data_source"
                            required
                        />
                    </v-flex>
                    <v-flex  sm4  v-if="dataset.type=='D' && dataset.source_type=='D'">
                        <b>Data Value</b><br/>
                        <v-text-field
                            class="mr-2 pt-1"
                            outline
                            v-validate="'required'"
                            data-vv-name="key_id"
                            type="text"
                            :error-messages="errors.collect('key_id')"
                            v-model="dataset.key_id"
                            required
                        />
                    </v-flex>
                    <v-flex  sm4  v-if="dataset.type=='D'  && dataset.source_type=='D'">
                        <b>Display Value</b><br/>
                        <v-text-field
                            class="mr-2 pt-1"
                            outline
                            v-validate="'required'"
                            data-vv-name="key_name"
                            type="text"
                            :error-messages="errors.collect('key_name')"
                            v-model="dataset.key_name"
                            required
                        />
                    </v-flex>
                    <v-flex xs4 mr-2 v-if="parameters.id">
                        <b>Status</b><br/>
                        <v-autocomplete attach   
                            class="style-input mr-2 pt-1"
                            label="Status"
                            v-validate="'required'"
                            data-vv-name="active"
                            item-text="name"
                            item-value="id"
                            :error-messages="errors.collect('active')"
                            v-model="dataset.active"
                            :items="active"
                        ></v-autocomplete>
                    </v-flex>
                </v-layout>
                    <Options v-if="dataset.source_type=='O'" :optionValues="JSON.parse(dataset.options)" v-on:optionChanged="optionChanged" />
                <v-layout class="justify-end">
                    <div class="form-btn2">
                        <v-btn @click="submit" small class="black white--text">Save</v-btn>
                        <v-btn @click="clear" small  class="black white--text">Clear</v-btn>
                    </div>
                </v-layout>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<style>
</style>

<script>
import Options from './Options.vue'
import DataSetModel from '@/api/service/DataSetService';
export default {
    $_veeValidate: {
    validator: 'new'
    },         
    components: {
        Options
    },
    props: [
      "parameters","dialog"
    ],
    data: () => ({
        saveCard: true,
        valid: true,
        dataset:{
            "type":"D",
            "source_type":"D",
            "options":JSON.stringify([{"dataSet":"","dataValues":""}])
        },
        sourceTypes:[
            {id:'D',name:'Database'},
            {id:'O',name:'Options'}
        ],
        settype:[
            {id:'D',name:'DropDown'},
            {id:'R',name:'Report'}
        ],
        active:[
            {"id":1,"name":"Active"},
            {"id":0,"name":"Inactive"}
        ],
    }),
    watch: {
        parameters() {
            if(this.parameters.id) {
                var $id = this.parameters.id
                    DataSetModel.findOne({id:$id})
                        .then(response => {
                        this.setdataset(response) 
                    }).catch(error => {
                }); 
            }
        }
    },
    created: function() {               
        if(this.parameters.id) {
            var $id = this.parameters.id
                DataSetModel.findOne({id:$id})
                    .then(response => {
                    this.setdataset(response) 
                }).catch(error => {
            }); 
        }
    },       
    methods: {
        setdataset($dataset){
            this.dataset = $dataset[0];
            console.log(this.dataset)
        },   
        getdataset(){
            DataSetModel.findAll({})
                .then(response => {
                    this.setdataset(response) 
                }).catch(error => {
            }); 
        },        
        closeDialog() {
            this.$emit('closeDialog',true)
        },
        submit () {
          var navigate = this.$router;
          var stores = this.$store;
              
          if(this.dataset.id) { 
            DataSetModel.update(this.dataset)
                .then(response => {
                    this.closeDialog()
                }).catch(error => {
                    console.log(error);
                    console.log('I am getting error')
            }); 
          } else {
            DataSetModel.create(this.dataset)
                .then(response => {
                    this.getdataset()
                    this.closeDialog()
                }).catch(error => {
                    console.log(error);
                    console.log('I am getting error')
                });
            }   
            //this.getdataset()                             
         },
        optionChanged($options) {
            this.dataset.options=JSON.stringify($options)
        },
        clear () {
            if(this.dataset.id) { 
                this.closeDialog()
                } else {  
                this.dataset = {}
                }
            }
        }
    };
</script>

<style scoped>
.style-input {
padding:0px;
margin:0px;
width:100%;
}
.style-input1 {
background-color:yellow;
}
</style>

